import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const PdfIcon: React.FC<Props> = ({
  color = "currentColor",
  ...svgProps
}) => {
  return (
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 15)}
      {...svgProps}
      viewBox="0 0 45 15"
      fill={color}
    >
      <text
        fontFamily="HelveticaNeue-Bold, Helvetica Neue"
        fontSize="12"
        fontWeight="700"
      >
        <tspan x="10.494" y="12">
          PDF
        </tspan>
      </text>
    </SVG>
  );
};
